import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../core/reducers';
import { Observable } from 'rxjs/Observable';
import * as actions from '../../core/actions/authentication';

@Component({
  selector: 'app-header',
  template: `
  <div id="masthead">
    <h2 class="offleft">Masthead</h2>
    <img class="ars-header" src="../images/ars.jpg" />
    <a href="http://www.ars.usda.gov" target="_blank" style="text-decoration:none!important;">
      <img src="../images/masthead_logo.jpg"
        alt="United States Department of Agriculture Agricultural Research Service"
        title="United States Department of Agriculture Agricultural Research Service" id="logo" border="0" />
      <span class="larger-header">Agricultural Research Service</span>
      <span class="small-header">U.S. Department of Agriculture</span>
    </a>
    <br class="clearfloat"/>
  </div>
  <div id="sidebar1">
    <div id="leftnavheader">
      BARC
    </div>
      <irar-left-navigation [isAdmin]="isAdmin$ | async"
                            [isSuperAdmin]="isSuperAdmin$ | async"
                            (logOut)="signout($event)"></irar-left-navigation>
    <div id="leftnavfooter">
      <img src="../images/quick_links_footer.gif" alt="" border="0" />
      <br class="clearfloat"/>
    </div>
</div>
  `
})
export class HeaderComponent {
  isAdmin$: Observable<boolean>;
  isSuperAdmin$: Observable<boolean>;
  constructor(private store: Store<fromRoot.State>) {
    this.isAdmin$ = this.store.select(fromRoot.getAuthIsAdmin);
    this.isSuperAdmin$ = this.store.select(fromRoot.getAuthIsSuperAdmin);
  }

  signout() {
    this.store.dispatch(new actions.LogoutAction());
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/header.ts